import Hotjar from "@hotjar/browser";
import mixpanel from "mixpanel-browser";
import { getConfig } from "../utils/environment.ts";
import { pushGTMEvent } from "./gtm/pushGTMEvent.ts";

let userUuid: string | undefined;
let userEmail: string | undefined;

export const initTracking = (user: { uuid: string; email: string }) => {
  const hotjarSiteId = 3919221;
  const hotjarVersion = 6;
  Hotjar.init(hotjarSiteId, hotjarVersion);
  Hotjar.identify(user.uuid, {
    email: user.email,
  });

  mixpanel.init(
    getConfig({
      dev: "92acec2068138fd47cf453a221573383",
      staging: "d417d87b0b9d5ff993a47919ebb3e7b5",
      prod: "7096d75ca49af7f199a6d5127992abf7",
    }),
    {
      persistence: "localStorage",
      debug: getConfig({ dev: true, staging: false, prod: false }),
    },
  );
  // XXX: Initiate the user in Mixpanel and creates it.
  // If you don't call it, then Mixpanel uses a random distinct_id identifier that is stored
  // in a cookie in order to associate following events to a given session (which is something
  // you would do for anonymous session, that we currently don't support as every user in our
  // app is authenticated).
  mixpanel.identify(user.uuid);

  // Set more properties to that user, which passes some hidden properties such as browser or location.
  mixpanel.people.set({
    $email: user.email,
  });

  userUuid = user.uuid;
  userEmail = user.email;

  // FIXME: mixpanel.reset() is not being used when logging out.
  // We miss a `useLogout` hook that would call mixpanel.reset(), resets the userUuid and userEmail
  // and actually calls Auth0 logout.
};

export const trackEvent = (
  eventName: string,
  payload: Record<string, unknown>,
  pushToGTM = false,
) => {
  const timestamp = new Date().toISOString();

  mixpanel.track(eventName, {
    ...payload,
    ...(userUuid && { user_uuid: userUuid }),
    ...(userEmail && { user_email: userEmail }),
    timestamp,
  });

  // XXX: All user usage of the app should go to Mixpanel, as we want to understand how users use the app.
  // Nevertheless, all events are not worth optimizing for in ads, so tracking them with GTM is not strictly
  // required. GTM can also be used for analytics, indeed, but we are not currently using it for that since
  // we have Mixpanel, we are only using it for ads.
  // We could also send everything to both Mixpanel and GTM, but it feels at this point like a waste of
  // network bandwidth + GTM resource (as every event will be handled by GTM web and server containers).
  if (pushToGTM) pushGTMEvent(`pimento.${eventName}`, payload);
};

export const updateUser = (properties: Record<string, string | null>) => {
  mixpanel.people.set({
    ...properties,
  });
};
